<template>
  <div
    class="v3-popup virtual-award-detail-popup"
    v-show="virtualAwardDetailPopupState"
  >
    <div class="v3-popup-mask" @click="handleCloseVirtualAwardDetail"></div>
    <div class="v3-popup-content">
      <div
        class="v3-popup-content-close"
        @click="handleCloseVirtualAwardDetail"
      ></div>
      <div class="v3-popup-content-title">{{ langData.vtCodeTitle }}</div>
      <div class="v3-popup-content-content">
        <div class="content-bbox">
          <div class="virtual-award-detail-code">
            {{ langData.giftCodeLabel }}{{ virtualAwardDetailCode }}
          </div>
          <div class="copy-code-btn btns" @click="copyCode">
            {{ hasCopied ? langData.copiedBtn : langData.copyBtn }}
          </div>
        </div>
        <div class="tips">{{ langData.useGiftCodeTips }}</div>
      </div>
      <div class="confirm-btn btns" @click="handleCloseVirtualAwardDetail">{{ langData.confirmBtn }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  virtualAwardDetailCode,
  virtualAwardDetailPopupState,
} from "@/hooks/useGetAward";

import useClipboard from "vue-clipboard3";
import LanguageHook from "@hooks/language";

const { langData } = LanguageHook();

const { toClipboard } = useClipboard();
const hasCopied = ref(false);

const copyCode = async () => {
  await toClipboard(virtualAwardDetailCode.value);
  hasCopied.value = true;
  setTimeout(() => {
    hasCopied.value = false;
  }, 1000);
};

const handleCloseVirtualAwardDetail = () => {
  virtualAwardDetailPopupState.value = false;
  virtualAwardDetailCode.value = "";
};
</script>
